// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemno-input[data-v-69606fa2] {\n  max-width: 6.5em;\n}\n.itemdesc-input[data-v-69606fa2] {\n  min-width: 15em;\n}\n.money-input[data-v-69606fa2] {\n  max-width: 5.5em;\n}\n.total-input[data-v-69606fa2] {\n  min-width: 5.5em;\n}\n.qty-input[data-v-69606fa2] {\n  max-width: 3.5em;\n}\n.partno-input[data-v-69606fa2] {\n  min-width: 6.5em;\n}\n.qty-width[data-v-69606fa2] {\n  max-width: 3.7em;\n}", ""]);
// Exports
module.exports = exports;
